import { render, staticRenderFns } from "./MessageGalleryLocked.vue?vue&type=template&id=a6bd616c&scoped=true&"
import script from "./MessageGalleryLocked.vue?vue&type=script&lang=ts&"
export * from "./MessageGalleryLocked.vue?vue&type=script&lang=ts&"
import style0 from "./MessageGalleryLocked.vue?vue&type=style&index=0&id=a6bd616c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bd616c",
  null
  
)

export default component.exports